module.exports = __webpack_public_path__ + "static/media/greater-icon.89dc26d1.svg";